// extracted by mini-css-extract-plugin
export default {"uploadPopup":"uploadMusicDonePopup_uploadPopup__BiA0p","title":"uploadMusicDonePopup_title__dwZh8","description":"uploadMusicDonePopup_description__0te9F"};